export default class MenuToggle {
  /**
  ** 実行
  ** @constructor
  **/    
  constructor() {
    this.getParam()
    this.init()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/    
  getParam() {
    //Hover Menu
    this.NavCnt = document.querySelectorAll(`[data-module='nav-hover']`)
    this.Child =document.querySelectorAll(`[data-module="sidebar-child"]`)
    this.GrandChild = document.querySelectorAll(`[data-module="sidebar-grandchlid"]`)
  }

  /**
  ** オブジェクトを初期化
  ** @init
  **/    
  init() {
    this.HoverMenu()
  }

  HoverMenu () {

    let Break = matchMedia('(min-width:769px)')

    if(Break.matches) {

      Array.prototype.forEach.call(this.NavCnt,(elem)=> {
        let
          Child = elem.children,
          ChildrenArray = Array.prototype.slice.call(Child)
        
        Array.prototype.forEach.call(ChildrenArray,(elem)=>{
  
          elem.addEventListener('mouseenter', ()=> {
            if(elem.classList.contains('is-nest')) {
              elem.querySelector('.l-sidebar__childlist').classList.add('is-show')
            }
          })
          const
            childNest = elem.querySelectorAll('.l-sidebar__childlist > .is-nest'),
            childNestArray = Array.prototype.slice.call(childNest)          
          Array.prototype.forEach.call(childNestArray,(elem)=>{
            elem.addEventListener('mouseenter', ()=> {
              elem.querySelector('.l-sidebar__grandchildlist').classList.add('is-show')
            })
          })          
          elem.addEventListener('mouseleave', ()=> {
            if(elem.classList.contains('is-nest')) {
              elem.querySelector('.l-sidebar__childlist').classList.remove('is-show')
            }
          })        
          Array.prototype.forEach.call(childNestArray,(elem)=>{
            elem.addEventListener('mouseleave', ()=> {
              elem.querySelector('.l-sidebar__grandchildlist').classList.remove('is-show')
            })
          })             
        })
      })
    } else {
      const
        toggle = document.querySelectorAll(`[data-module='nav-tap-slide']`),
        toggleArray = Array.prototype.slice.call(toggle),

        backToggle = document.querySelectorAll(`.l-sidebar__list [data-module="btn-back"] > span`),
        backToggleArray =  Array.prototype.slice.call(backToggle),

        childBackToggle = document.querySelectorAll(`.l-sidebar__list > [data-module="btn-back-child"] > span`),
        childBackToggleArray = Array.prototype.slice.call(childBackToggle),

        childToggle = document.querySelectorAll(`[data-module='nav-hover'] > .is-nest`),
        childToggleArray =  Array.prototype.slice.call(childToggle),        

        grandChildBackToggle = document.querySelectorAll(`.l-sidebar__list [data-module="btn-back-grandchild"] > span`),
        grandChildBackToggleArray =  Array.prototype.slice.call(grandChildBackToggle),
        
        childItem = document.querySelector('.l-sidebar__cnt--sp'),

        grandChildToggle = document.querySelectorAll(`[data-module="sidebar-child"] > .is-nest`),
        grandChildToggleArray =  Array.prototype.slice.call(grandChildToggle),
        NavCont = document.querySelector(`[data-module='heightChange']`)



      

      //カテゴリを押したときの反応
      Array.prototype.forEach.call(toggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          childItem.classList.add('is-slide')
          var bgheight = elem.nextElementSibling.clientHeight;
          NavCont.style.height =bgheight + 90 + 'px'
          e.stopPropagation()
        })
      })

      // カテゴリへ戻るボタン
      Array.prototype.forEach.call(backToggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          childItem.classList.remove('is-slide')
          var backheight = document.querySelector('.l-sidebar__cnt--sp').clientHeight
          NavCont.style.height = backheight + 90 + 'px'
          e.stopPropagation()
        })
      })
      
      
      //子要素
      Array.prototype.forEach.call(childToggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          elem.querySelector('.l-sidebar__childlist').classList.add('is-show')
          childItem.classList.add('is-slidechild')
          var bgheight = elem.children[0].clientHeight
          NavCont.style.height = bgheight+ 90 + 'px'
          e.stopPropagation()
        })
      })      


      //1つめのメニューに戻るボタン
    
      Array.prototype.forEach.call(childBackToggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          childItem.classList.remove('is-slidechild')
          var childcnt = elem.parentNode.parentNode
          childcnt.classList.remove('is-show')
          var chbgheight = document.querySelectorAll(`[data-module="nav-hover"]`)[1].clientHeight
          NavCont.style.height =chbgheight+ 90 + 'px' 
          e.stopPropagation()
        })
      })
                 

      //孫要素
      Array.prototype.forEach.call(grandChildToggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          elem.querySelector('.l-sidebar__grandchildlist').classList.add('is-show')
          childItem.classList.add('is-slidegrandchild')
          var bgheight = elem.children[0].clientHeight
          NavCont.style.height = bgheight + 90 + 'px'
          e.stopPropagation()
        })
      })

    
          
      Array.prototype.forEach.call(grandChildBackToggleArray,(elem)=> {
        elem.addEventListener('click', (e)=> {
          childItem.classList.remove('is-slidegrandchild')
          var grchildcnt = elem.parentNode.parentNode
          grchildcnt.classList.remove('is-show')
          var grandbackheight = elem.parentNode.parentNode.parentNode.parentNode.clientHeight
          NavCont.style.height = grandbackheight+ 90 + 'px'
          e.stopPropagation()

        })        
      })

    }
  }

}